// senderInitials — the "Init" column's display rule (WEL-135). Its own pure
// module (no `./api`, no JSX) so it stays unit-testable under node:test/tsx,
// same reason intakeAnimalsLabel and leaseholderChangeMatch live apart.

/**
 * "Miles Scruggs" → "MS". First + last initial only; a single name gives one
 * letter, and a middle name is skipped (first and last are what identify the
 * sender at a glance).
 *
 * Returns '' when nobody sent it — condition reports, rental verifications and
 * the agreements the system sends on its own have no human sender. The cell then
 * renders EMPTY rather than a dash: the column exists to be scanned, and a
 * column full of placeholders would defeat that.
 */
export function initialsOf(fullName: string | undefined): string {
  const parts = (fullName ?? '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '';
  const first = parts[0]![0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]![0] ?? '') : '';
  return `${first}${last}`.toUpperCase();
}
